$( document ).ready(function() {
    $('.final-choise-button').on('click',function(){
    /** write related code inside **/
      ToWrapUpState();
    });
	$("#endSceneWrapper").disable().hide();
 });
 
 function ToWrapUpState()
 {
	$("#choiseWrapper").disable().hide();
	$("#endSceneWrapper").enable().show();
	
 }
 
 $.fn.disable = function() {
    return this.each(function() {
        if (typeof this.disabled != "undefined") this.disabled = true;
    });
}

$.fn.enable = function() {
    return this.each(function() {
        if (typeof this.disabled != "undefined") this.disabled = false;
    });
}